import * as React from 'react';
import {
  List,
  Datagrid,
  TextField,
  SearchInput,
  ImageField,
  BooleanField,
  NumberField,
  useTranslate,
  FunctionField,
  TextInput,
} from 'react-admin';
import { useBackendTranslate } from '../../hooks/settings/useBackendTranslation';
import { FilterProduct } from './listPage/FilterProduct';

export default function ResourceList(props: any) {
  const getTranslation = useBackendTranslate();
  const t = useTranslate();

  return (
    <List {...props} aside={<FilterProduct />}>
      <Datagrid rowClick='edit'>
        <NumberField source='id' />
        <ImageField source={'image'} />
        <FunctionField
          label={t('name')}
          render={(record: any) => getTranslation(record, 'name')}
        />
        <TextField source='reference' />
        <TextField source='price' />
        <TextField source='quantity' />
        <TextField source='unit' />
        <TextField source='sku' />
        <BooleanField source='isActive' />
        <BooleanField source='isFeatured' />
      </Datagrid>
    </List>
  );
}
